import { render, staticRenderFns } from "./ClothseleQrcode.vue?vue&type=template&id=f765d670&scoped=true"
import script from "./ClothseleQrcode.vue?vue&type=script&lang=js"
export * from "./ClothseleQrcode.vue?vue&type=script&lang=js"
import style0 from "./ClothseleQrcode.vue?vue&type=style&index=0&id=f765d670&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f765d670",
  null
  
)

export default component.exports